var _g, _rect, _rect2, _g2, _rect3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPainBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(6 140 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 20,
    width: 48,
    height: 100,
    rx: 6,
    fill: "#FFFFFF",
    stroke: "#E4DCCF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 34,
    width: 32,
    height: 5,
    rx: 2.5,
    fill: "#EAE3D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 48,
    width: 32,
    height: 5,
    rx: 2.5,
    fill: "#EAE3D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 62,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#EAE3D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 92,
    width: 32,
    height: 6,
    rx: 3,
    fill: "#FBD89B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 40,
    width: 66,
    height: 92,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E4DCCF",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 50,
    width: 46,
    height: 20,
    rx: 4,
    fill: "#FEF4E3",
    stroke: "#F6E2BD",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#EDEFF3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 80,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 80,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 80,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 98,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 98,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 98,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 116,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 116,
    width: 12,
    height: 12,
    rx: 3
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 116,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#F59E0B"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 142 118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 100,
    width: 60,
    height: 38,
    rx: 7,
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 110,
    width: 60,
    height: 7,
    fill: "#DD8B0C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 124,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#FCE3B5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainBilling);
export default __webpack_public_path__ + "static/media/pain-billing.a17917f894e781479a4db71c08f9aae2.svg";
export { ForwardRef as ReactComponent };